export class BackdropConfig {
  constructor(shouldPropagate: boolean, visible: boolean, tappable: boolean) {
    this.shouldPropagate = shouldPropagate;
    this.visible = visible;
    this.tappable = tappable;
  }

  public shouldPropagate: boolean;
  public visible: boolean;
  public tappable: boolean;
}
